// Copyright 2025, University of Maryland, All Rights Reserved
export const PAGE_SIZE = 10
export const DEFAULT_EMPTY = 'No documents available'
